import {queries} from '@cypro/engine/queries'
import {useZero as useZeroClient} from '@rocicorp/zero/react'
import {findLabelPrescriptions, type LabelScanCode} from '../scan-code'

/** One-off lookup of the prescriptions a scanned preparation label points at; waits for the server result. */
export function useFindLabelPrescriptions() {
  // the app's useZero spreads the client into a plain object, which drops prototype methods like run()
  const zero = useZeroClient()

  return async function find(label: LabelScanCode) {
    const candidates = await zero.run(queries.patientsTherapies.getSequencesByInternalId(label.prescriptionNumber), {
      type: 'complete',
    })
    return findLabelPrescriptions(label, [...candidates])
  }
}
